import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
      getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminGpsmap1242xsv = () => {
  console.log('🎯 GarminGpsmap1242xsv component loading');
  
  const product = findProductById("gpsmap-1242xsv");
  
  if (!product) {
    console.error('Product not found:', "gpsmap-1242xsv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-1242xsv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminGpsmap1242xsv; 